<div class="urgency-boost-example" [class.is-mobile]="isMobile">
  <div class="standalone-section">
    <pdq-heading element="h6">Order summary</pdq-heading>
    @for (line of sampleLineItems; track line.productId) {
      <div class="line-item">
        <div class="line-item__thumb"></div>
        <div class="line-item__main">
          <div class="line-item__name">{{ line.name }}</div>
          <div class="line-item__qty">{{ line.quantity }} item{{ line.quantity > 1 ? 's' : '' }}</div>
          <div
            class="line-item__badges"
            [style.padding-block-start]="spaceAboveBadgeToPadding(template?.layout?.spaceAboveBadge)">
            @for (badge of renderBadgesFor(line); track badge.id) {
              <span
                class="urgency-pill"
                [style.background-color]="badge.backgroundColor || null"
                [style.color]="badge.textColor || null"
                [style.border-radius]="cornerRadiusToPx(badge.cornerRadius)">
                @if (badge.icon) {
                  <pdq-icon [icon]="badge.icon" size="small" class="urgency-pill__icon"></pdq-icon>
                }
                <span class="urgency-pill__text" [innerHTML]="badge.text"></span>
              </span>
            }
          </div>
        </div>
        <div class="line-item__price">{{ line.price }}</div>
      </div>
    }
  </div>
</div>
